export default __webpack_public_path__ + "static/media/group-logo.777ed086.svg";